import { View } from "@react-pdf/renderer";

export const HorizontalLine = ({ sx }) => (
  <View style={{ borderBottom: "1px solid #000", width: "100%", ...sx }} />
);
